import React from "react"
import { useSelector } from "react-redux"

import {
    PAYMENT_BUY,
    PAYMENT_UPGRADE,
    PAYMENT_DOWNGRADE,
    PAYMENT_CURRENCY,
} from "const"
import { StoreType } from "client/store"
import {
    UserIcon,
    DateFormatter,
} from "client/components"

import {
    BillingHistoryWrapper,
    HistoryWrapper,
    HistoryTitleWrapper,
    HistoryBodyWrapper,
    HistoryItem,
    HistoryItemInfo,
    HistoryItemTitle,
    HistoryTotalPrice,
    HistoryItemPrice,
} from "./styled"

const BillingHistory = () => {
    const billingHistory = useSelector((state: StoreType) => state.billing.billingHistory)
    const userList = useSelector((state: StoreType) => state.user.userList)
    const lang = useSelector((state: StoreType) => state.system.lang)

    // TODO: delete billing history with confirm modal
    return (
        <BillingHistoryWrapper>
            {
                billingHistory.map((history) => {
                    const {
                        userId,
                        createdAt,
                        billingHistoryContent,
                    } = history
                    let billingAmount = 0

                    const historyBody = (
                        <HistoryBodyWrapper>
                            {
                                billingHistoryContent.map((content) => {
                                    const {
                                        packageFrom,
                                        packageTo,
                                        packageAction,
                                        librarySet,
                                        cost,
                                    } = content

                                    billingAmount += cost

                                    let action: string
                                    if (packageAction === PAYMENT_UPGRADE) action = lang.packageUpgraded
                                    if (packageAction === PAYMENT_DOWNGRADE) action = lang.packageDowngraded

                                    return (
                                        <HistoryItem key={content.id}>
                                            {
                                                packageFrom && packageTo && packageAction && (
                                                    <HistoryItemInfo>
                                                        <HistoryItemTitle>{packageTo.name}</HistoryItemTitle>
                                                        {
                                                            packageAction !== PAYMENT_BUY
                                                            && <div>{`${action} ${packageFrom.name}`}</div>
                                                        }
                                                        <div>{`1 - ${packageTo.maxUsers} ${lang.users}`}</div>
                                                        <div>{lang.packageDuration}</div>
                                                    </HistoryItemInfo>
                                                )
                                            }
                                            {
                                                librarySet && (
                                                    <HistoryItemInfo>
                                                        <HistoryItemTitle>{librarySet.name}</HistoryItemTitle>
                                                        <div>{librarySet.publicId}</div>
                                                    </HistoryItemInfo>
                                                )
                                            }

                                            <HistoryItemPrice>{`${cost} ${PAYMENT_CURRENCY}`}</HistoryItemPrice>
                                        </HistoryItem>
                                    )
                                })
                            }
                        </HistoryBodyWrapper>
                    )

                    return (
                        <HistoryWrapper key={history.id}>
                            <HistoryTitleWrapper>
                                <DateFormatter date={createdAt} />
                                <UserIcon user={userList[userId]} size="sm" />
                                <HistoryTotalPrice>{`${billingAmount} ${PAYMENT_CURRENCY}`}</HistoryTotalPrice>
                            </HistoryTitleWrapper>
                            { historyBody }
                        </HistoryWrapper>
                    )
                })
            }
        </BillingHistoryWrapper>
    )
}
export default BillingHistory
